import React from 'react';
import Configurator from './Configurator';

interface KonfiguratorConfig {
  products: string;
  showVisualizer: boolean;
  theme: string;
  compact: boolean;
}

interface ConfiguratorWrapperProps {
  config?: KonfiguratorConfig;
  containerId?: string;
}

/**
 * Outermost shell of the configurator. Sets the drafting-paper ground so
 * that the WP page around it doesn't leak grey `bg-gray-50` into the
 * sheet. Everything visible inside this shell obeys Direction A.
 */
export default function ConfiguratorWrapper({ config, containerId }: ConfiguratorWrapperProps) {
  const defaultConfig: KonfiguratorConfig = {
    products: 'all',
    showVisualizer: true,
    theme: 'default',
    compact: false,
  };

  const finalConfig = { ...defaultConfig, ...config };

  // Theme-scoped modifiers (kept for backward-compat; simple/compact
  // legacy consumers still work).
  const themeClass =
    finalConfig.theme === 'simple'
      ? 'sv-theme-simple'
      : finalConfig.compact
        ? 'sv-theme-compact'
        : '';

  return (
    <div className={`sv-sheet-plain min-h-screen ${themeClass}`}>
      <Configurator config={finalConfig} containerId={containerId} />
    </div>
  );
}
